/**
 * Memoize a function
 * Usage: const memoizedFunc = memoize(func)
 * Will cache the result of func for each unique set of arguments
 * @param {Function} func
 * @returns {Function}
 */
export function memoize(func) {
    const cache = {}
    return function (...args) {
      const key = JSON.stringify(args)
      if (!cache[key]) {
        cache[key] = func.apply(this, args)
      }
      return cache[key]
    }
}



// WEBPACK FOOTER //
// ./lib/memoize.js